import React from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import Footer from "../views/Footer";
import Navbar from "../views/Navbar";

interface Props {}

const Root = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  overflow: hidden;
  position: relative;
`;

const Container = styled.div`
  display: flex;
  flex: 1 1 auto;
  overflow: hidden;
  position: relative;
`;

const Content = styled.div`
  flex: 1 1 auto;
  height: 100%;
  overflow: auto;
  position: relative;
  -webkit-overflow-scrolling: touch;
  padding-top: 65px;
`;

const AuthLayout: React.FC<Props> = (props) => {
  return (
    <Root>
      <Navbar />
      <Wrapper>
        <Container>
          <Content>
            <Outlet />
          </Content>
        </Container>
      </Wrapper>
      <Footer />
    </Root>
  );
};

export default AuthLayout;
